export const LocalStorageKey = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_INFO: 'user_info'
};

export const ENUM_ROLE = {
  ADMIN: 'ADMIN',
  EMPLOYEE: 'EMPLOYEE'
};

export const ENUM_TYPE_MESS = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning'
};

export const CONST_SYS = {
  PASS_RESET: '@@okvip@@'
};

export const CONST_SITE = {
  OK9: 'f8bet'
};

export const LIST_SITE = [
  {
    key: CONST_SITE.OK9,
    name: CONST_SITE.OK9
  }
];

export const SETTING_KEYS = {
  TITLE: 'title',
  NO_DATA: 'no-data',
  PRIZE_STRUCTURE: 'prize_structure',
  RULE: 'rule',
  RULE_XOSO: 'rule_xoso'
};
